import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from "@mui/material";
import { Link } from "react-router-dom";
import CircleIcon from "@mui/icons-material/Circle";

const Dot = () => {
  return (
    <ListItemIcon sx={{ minWidth: "20px", opacity: 0.5 }}>
      <CircleIcon sx={{ color: "primary.main", fontSize: "0.5rem" }} />
    </ListItemIcon>
  );
};

const CustomLeftNavigation = ({ config }) => {
  return (
    <List
      dense
      subheader={
        <ListSubheader component="div" disableGutters>
          <ListItemButton component={Link} to={`/${config.path}`}>
            <ListItemText primary={config.title} />
          </ListItemButton>
        </ListSubheader>
      }
    >
      {config.subPages.map((page, index) => (
        <ListItem key={index} disablePadding>
          <ListItemButton component={Link} to={`/${config.path}/${page.path}`}>
            <Dot />
            <ListItemText primary={page.title} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default CustomLeftNavigation;
